import React from 'react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { GermanFlag, USFlag } from './FlagIcons';

const LanguageSwitcher = ({ className = "" }) => {
  const { currentLanguage, switchLanguage } = useLanguage();

  // Check if this is mobile view based on className
  const isMobile = className.includes('md:hidden');

  return (
    <div className={`flex items-center ${className}`}>
      <div className={`flex bg-white/10 rounded-md overflow-hidden ${isMobile ? 'scale-95' : ''}`}>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => switchLanguage('de')}
          className={`${isMobile ? 'px-2 py-1.5' : 'px-3 py-1'} text-xs font-medium transition-all duration-200 flex items-center gap-1.5 ${
            currentLanguage === 'de'
              ? 'bg-white/20 text-white'
              : 'text-white/60 hover:text-white hover:bg-white/10'
          }`}
        >
          <GermanFlag className={`${isMobile ? 'w-4 h-3' : 'w-4 h-3'}`} />
          <span className={`${isMobile ? 'text-xs' : 'text-xs'}`}>DE</span>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => switchLanguage('en')}
          className={`${isMobile ? 'px-2 py-1.5' : 'px-3 py-1'} text-xs font-medium transition-all duration-200 flex items-center gap-1.5 ${
            currentLanguage === 'en'
              ? 'bg-white/20 text-white'
              : 'text-white/60 hover:text-white hover:bg-white/10'
          }`}
        >
          <USFlag className={`${isMobile ? 'w-4 h-3' : 'w-4 h-3'}`} />
          <span className={`${isMobile ? 'text-xs' : 'text-xs'}`}>EN</span>
        </Button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;